var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewer)?_c('div',{staticClass:"diff-file preview-container"},[_c(_vm.viewer,{tag:"component",attrs:{"diff-mode":_vm.diffMode,"new-path":_vm.fullNewPath,"old-path":_vm.fullOldPath,"project-path":_vm.projectPath}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }